import { Injectable } from '@angular/core';
import { environment } from '../../environment/environment';
import { UserProfile } from '../interfaces/UserProfile';
import { ProjectInfo } from '../all-query-table/all-query-table.component';
import { GetFilterQueryResponse } from '../../models/filter-payload.model';
import { FilterCriteriaResponse } from './filter-criteria.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  redirectUrl: string = environment.authClientConfiguration.redirect_url;
  profile: UserProfile = {} as UserProfile;
  isCreateProject: boolean = true;
  selectedProject: ProjectInfo = {} as ProjectInfo;
  _projectId: string = '';
  optionalNotesForSendingApprovalRequests: string = '';
  approvalStatus: string = '';
  isRolloutUpdated: boolean = false;
  selectedGUID: string = '';
  selectedFilterName: string = '';
  selectedQuery: FilterCriteriaResponse | null = null;
  queryCreationMode: 'default' | 'empty' | 'template' | 'fav_query' = 'default';
  ownerTemplateChoice='edit';
  constructor() {}

  set projectId(id: string) {
    this._projectId = id;
  }

  get projectId(): string {
    return this._projectId;
  }

  setSelectedFilter(guid: string, filterName: string): void {
    this.selectedGUID = guid;
    this.selectedFilterName = filterName;
  }

  compareTwoObjects(original: any, current: any): boolean {
    const keysToCompareObjects = Object.keys(original);
    return keysToCompareObjects.every(key => original[key] === current[key]);
  }
}
